import React from "react"
import PropTypes from "prop-types"
import Select from "react-select"

import { etiquetaFecha } from "../useOrdersCreate"

const OrderFilters = ({
  clients,
  clientId,
  dates,
  date,
  addresses,
  addressId,
  address,
  onChangeClient,
  onChangeDate,
  onChangeAddress,
}) => {
  const opcionesCliente = clients.map(cliente => ({
    label: cliente.company_name,
    value: cliente.id,
  }))

  const clienteSeleccionado =
    opcionesCliente.find(opcion => opcion.value === clientId) || null

  return (
    <div className="ped-card ped-filters ped-anim">
      <div className="ped-filters-row">
        <label className="ped-inline-label" htmlFor="ped-cliente">
          Clientes
        </label>
        <Select
          inputId="ped-cliente"
          classNamePrefix="ped-select"
          options={opcionesCliente}
          value={clienteSeleccionado}
          onChange={opcion => onChangeClient(opcion ? opcion.value : null)}
          placeholder="- Seleccionar cliente -"
          noOptionsMessage={() => "Sin clientes"}
          isClearable
        />

        <label className="ped-inline-label" htmlFor="ped-fecha">
          Fecha
        </label>
        <select
          id="ped-fecha"
          className="ped-field ped-field-corto"
          value={date || ""}
          onChange={event => onChangeDate(event.target.value)}
          disabled={dates.length === 0}
        >
          {dates.length === 0 && (
            <option value={date}>{etiquetaFecha(date)}</option>
          )}
          {dates.map(dia => (
            <option key={dia} value={dia}>
              {etiquetaFecha(dia)}
            </option>
          ))}
        </select>
      </div>

      <div className="ped-filters-row">
        <label className="ped-inline-label" htmlFor="ped-direccion">
          Dirección de entrega
        </label>
        <select
          id="ped-direccion"
          className="ped-field"
          value={addressId || ""}
          onChange={event => onChangeAddress(Number(event.target.value))}
          disabled={addresses.length === 0}
        >
          {addresses.length === 0 && (
            <option value="">- Seleccionar dirección -</option>
          )}
          {addresses.map(direccion => (
            <option key={direccion.id} value={direccion.id}>
              {direccion.address_string}
            </option>
          ))}
        </select>

        <span className="ped-inline-label">Región de entrega</span>
        <span className="ped-region">{address?.region?.name || "—"}</span>
      </div>
    </div>
  )
}

OrderFilters.propTypes = {
  clients: PropTypes.array.isRequired,
  clientId: PropTypes.number,
  dates: PropTypes.array.isRequired,
  date: PropTypes.string,
  addresses: PropTypes.array.isRequired,
  addressId: PropTypes.number,
  address: PropTypes.object,
  onChangeClient: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func.isRequired,
  onChangeAddress: PropTypes.func.isRequired,
}

export default OrderFilters
